import EmojiData from "@emoji-mart/data/sets/14/apple.json";
import Picker from "@emoji-mart/react";

function EmojiPicker({ handleGetEmoji }) {

  /* Function definition for Emoji Picker - On change */
  const handleEmojiSelect = (emoji) => {
    handleGetEmoji(emoji.native);
  };
  /* Function definition for Emoji Picker - On change */

  return (
    <>
      <Picker
        set="native"
        data={EmojiData}
        onEmojiSelect={handleEmojiSelect}
        emojiButtonSize={27}
        emojiSize={20}
        previewPosition="none"
      />
    </>
  );
}

export default EmojiPicker;
